/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type { GetReportsDashboardOverviewQueryResponse } from '../../types/GetReportsDashboardOverview'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getReportsDashboardOverview } from '../../clients/getReportsDashboardOverview'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getReportsDashboardOverviewQueryKey = () =>
  [{ url: '/api/v1/reports/dashboard/overview/' }] as const

export type GetReportsDashboardOverviewQueryKey = ReturnType<
  typeof getReportsDashboardOverviewQueryKey
>

export function getReportsDashboardOverviewQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = getReportsDashboardOverviewQueryKey()
  return queryOptions<
    GetReportsDashboardOverviewQueryResponse,
    ResponseErrorConfig<Error>,
    GetReportsDashboardOverviewQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getReportsDashboardOverview({
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @description Flat set of metric cards for the reports dashboard header. Returns {} when the company has no deal-report rows; total_pipeline_value is present only when the enable_total_pipeline_value feature flag is on for the requesting user's company.
 * @summary Reports dashboard overview metric cards
 * {@link /api/v1/reports/dashboard/overview/}
 */
export function useGetReportsDashboardOverview<
  TData = GetReportsDashboardOverviewQueryResponse,
  TQueryData = GetReportsDashboardOverviewQueryResponse,
  TQueryKey extends QueryKey = GetReportsDashboardOverviewQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetReportsDashboardOverviewQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? getReportsDashboardOverviewQueryKey()

  const query = useQuery(
    {
      ...getReportsDashboardOverviewQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
